import * as action_types from "./constants";
import {
  EquipmentListType,
  GetEquipmentDetailByIdType,
  GetMaterialDetailByIdType,
  MaterialListType,
} from "./types";

export type myCompanyState = {
  materialListData: {
    loader: boolean;
    data: MaterialListType[] | null;
    count: number;
  };
  materialDetailData: {
    loader: boolean;
    data: GetMaterialDetailByIdType | null;
  };

  equipmentListData: {
    loader: boolean;
    data: EquipmentListType[] | null;
    count: number;
  };
  equipmentDetailData: {
    loader: boolean;
    data: GetEquipmentDetailByIdType | null;
  };
};

const initialState: myCompanyState = {
  materialListData: {
    loader: true,
    data: null,
    count: 0,
  },
  materialDetailData: {
    loader: true,
    data: null,
  },
  equipmentListData: {
    loader: true,
    data: null,
    count: 0,
  },
  equipmentDetailData: {
    loader: true,
    data: null,
  },
};

type MyCompanyActionType =
  | {
      type: typeof action_types.MATERIAL_LISTING;
      data: {
        payload: MaterialListType[];
        loading: boolean;
        count: number;
      };
    }
  | {
      type: typeof action_types.GET_MATERIAL_DETAILS;
      data: { payload: GetMaterialDetailByIdType; loading: boolean };
    }
  | {
      type: typeof action_types.EQUIPMENT_LISTING;
      data: {
        payload: EquipmentListType[];
        loading: boolean;
        count: number;
      };
    }
  | {
      type: typeof action_types.GET_EQUIPMENT_DETAILS;
      data: { payload: GetEquipmentDetailByIdType; loading: boolean };
    };

const myCompanyReducer = (
  state = initialState,
  action: MyCompanyActionType
): myCompanyState => {
  const { type, data } = action;
  switch (type) {
    case action_types.MATERIAL_LISTING:
      return {
        ...state,
        materialListData: {
          loader: data?.loading,
          data: data?.payload,
          count: data?.count,
        },
      };

    case action_types.GET_MATERIAL_DETAILS:
      return {
        ...state,
        materialDetailData: { data: data?.payload, loader: data?.loading },
      };

    case action_types.EQUIPMENT_LISTING:
      console.log("Reducer Equipment Listing Data: ", data);
      return {
        ...state,
        equipmentListData: {
          loader: data?.loading,
          data: data?.payload,
          count: data?.count,
        },
      };

    case action_types.GET_EQUIPMENT_DETAILS:
      return {
        ...state,
        equipmentDetailData: { data: data?.payload, loader: data?.loading },
      };

    default:
      return state;
  }
};

export default myCompanyReducer;
